import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TimeToLeaveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"time_to_leave"}/>
}
